import { LazyQueryResultTuple, OperationVariables } from '@apollo/client';
import { getApolloLink, useApolloLazyQuery, useCookie } from '@netfront/common-library';

import { IUseEkardoLazyQueryInputVariables } from './useEkardoLazyQuery.interfaces';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useEkardoLazyQuery = <TData = any, TVariables extends OperationVariables = OperationVariables>({
  apolloLink,
  options,
  product,
  query,
  token,
}: IUseEkardoLazyQueryInputVariables<TData, TVariables>): LazyQueryResultTuple<TData, TVariables> => {
  const { getAccessTokenCookie, getImpersonatedUserAccessTokenCookie, getImpersonatedUserTemporaryTokenCookie, getTemporaryTokenCookie } =
    useCookie();

  const accessToken = getImpersonatedUserAccessTokenCookie() ?? getAccessTokenCookie();
  const temporaryToken = getImpersonatedUserTemporaryTokenCookie() ?? getTemporaryTokenCookie();

  const authenticationLink = getApolloLink({
    apiName: 'ekardo',
    product,
    token: token ?? accessToken ?? temporaryToken,
  });

  return useApolloLazyQuery<TData, TVariables>({
    apiName: 'ekardo',
    apolloLink: apolloLink ?? authenticationLink,
    options,
    query,
  });
};

export { useEkardoLazyQuery };
